import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ValveViewModel } from 'src/app/shared/models/autogenerated-piping';
import { ValveSpecModalComponent, ValveSpecModalData } from 'src/app/search/valve-spec-modal/valve-spec-modal.component';

@Component({
    selector: 'app-clone-valve-button',
    templateUrl: './clone-valve.component.html',
    styleUrls: ['./clone-valve.component.scss'],
    standalone: false
})
export class CloneValveButtonComponent {
  @Input() valve: ValveViewModel;

  constructor(private dialog: MatDialog) {}

  openCloneDialog(): void {
    if (!this.valve?.id) {
      return;
    }

    const dialogData: ValveSpecModalData = {
      mode: 'clone',
      valveId: this.valve.id,
      valveTag: this.valve.tag.split('_')[0]
    };

    this.dialog.open(ValveSpecModalComponent, {
      width: '650px',
      disableClose: false,
      data: dialogData
    });
  }
}
